export const DatasetPatentApiDto = Symbol.for('DatasetPatentApiDto');
